'use client';

import { Button } from '@chakra-ui/react';
import type { ButtonProps } from '@chakra-ui/react';
import { useFormContext } from 'react-hook-form';

import { useFormConfig } from '../../../providers';

export const SubmitButton = ({ children, ...buttonProps }: ButtonProps) => {
	const { formState } = useFormContext();
	const {
		isDirty, isLoading, isSubmitting, isValid,
	} = formState;
	const { disableSubmit } = useFormConfig();

	const isDisabledOnLoading = disableSubmit.onLoading && isLoading;
	const isDisableOnSubmitting = disableSubmit.onSubmitting && isSubmitting;
	const isDisabledWhenIsNotDirty = disableSubmit.whenIsNotDirty && !isDirty;
	const isDisabledWhenNotValid = disableSubmit.whenNotValid && !isValid;

	const isDisabled = [
		isDisabledOnLoading,
		isDisableOnSubmitting,
		isDisabledWhenIsNotDirty,
		isDisabledWhenNotValid,
	].some(Boolean);

	return (
		<Button
			{...buttonProps}
			disabled={isDisabled}
			loading={isSubmitting}
			type="submit"
		>
			{children}
		</Button>
	);
};
